export default __webpack_public_path__ + "static/media/uploader-caresens-3.26b14ee5.png";